const OrderTrackListItemContentLoader = () => {
  return (
    <div className="border-2 border-accents rounded-lg p-4">
      <div className="h-5 w-1/2 bg-light_gray rounded-sm animate-pulse"></div>

      <div className="space-y-1 my-4">
        <div className="w-1/2 h-2.5 bg-light_gray rounded-sm animate-pulse"></div>
        <div className="w-3/4 h-2.5 bg-light_gray rounded-sm animate-pulse"></div>
      </div>

      <div className="space-y-1">
        <div className="w-1/2 h-2.5 bg-light_gray rounded-sm animate-pulse"></div>
        <div className="w-3/4 h-2.5 bg-light_gray rounded-sm animate-pulse"></div>
      </div>
    </div>
  );
};

export default OrderTrackListItemContentLoader;
